import styled from 'styled-components';

import { ActionMenu } from 'ui/actionMenu';
import {
  ActionMenuOption,
  AllowedActionMenuElements,
  MENU_ALIGNMENTS,
  MENU_DIRECTIONS,
} from 'ui/actionMenu/types';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { ChevronDown } from 'ui/icons/navigation/ChevronDown';
import { NoOp } from 'utils/noop';

// expected as button & action menu together
const ComboButton = styled.div`
  align-items: center;
  display: flex;
  > *:not(:only-child) {
    &:first-child {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
    &:last-child > div > button {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
    }
  }
`;

export type UploadComboConfig = {
  label: string | React.ReactNode;
  onClick: NoOp;
  actions: Partial<ActionMenuOption>[];
};

export const uploadButtonComboTestIds = {
  button: 'cl-upload-button-combo-button',
};

export const UploadButtonCombo = ({
  config,
  variant = BUTTON_VARIANTS.PRIMARY,
}: { config: UploadComboConfig; variant?: BUTTON_VARIANTS }) => {
  const actionMenuOptions = config.actions.map((action) => {
    return {
      ...action,
      as: AllowedActionMenuElements.Button,
    };
  }) as ActionMenuOption[];

  return (
    <ComboButton>
      <Button
        data-test={uploadButtonComboTestIds.button}
        onClick={config.onClick}
        size={BUTTON_SIZES.LARGE}
        variant={variant}
      >
        <span>{config.label}</span>
      </Button>
      {!!actionMenuOptions.length && (
        <ActionMenu
          align={MENU_ALIGNMENTS.RIGHT}
          direction={MENU_DIRECTIONS.BOTTOM}
          options={actionMenuOptions}
        >
          <IconButton size={BUTTON_SIZES.LARGE} variant={variant}>
            <ChevronDown height={16} width={16} />
          </IconButton>
        </ActionMenu>
      )}
    </ComboButton>
  );
};

export default UploadButtonCombo;
